export class PetDetailModel {
    pet_no: number
    client_no: number
    pet_name: string
    weight: number
    sex: string
    dob: any
    neuter: string
    rabieDate: any
    active: string
    temperature: number
    height: number
    pet_code: string
    picture: string
    breed_name: string
    color_name: string
    specie_name: string
    breed: number
    color: number
    specie: number
    tag_no: number
    selected: boolean
    age: number
    blood_pressure: string
    rabies: string
    chip_no: string
    assigned_doctor: string
 
    constructor(
        pet_no: number,
        client_no: number,
        pet_name: string,
        weight: number,
        sex: string,
        dob: any,
        neuter: string,
        rabieDate: any,
        active: string,
        temperature: number,
        height: number,
        pet_code: string,
        picture: string,
        breed_name: string,
        color_name: string,
        specie_name: string,
        breed: number,
        color: number,
        specie: number,
        tag_no: number,
        selected: boolean,
        age: number,
        blood_pressure: string,
        rabies: string,
        chip_no: string,
        assigned_doctor: string
    ) {
        this.pet_no = pet_no
        this.client_no = client_no
        this.pet_name = pet_name
        this.weight = weight
        this.sex = sex
        this.dob = dob
        this.neuter = neuter
        this.rabieDate = rabieDate
        this.active = active
        this.temperature = temperature
        this.height = height
        this.pet_code = pet_code
        this.picture = picture
        this.breed_name = breed_name
        this.color_name = color_name
        this.specie_name = specie_name
        this.breed = breed
        this.color = color
        this.specie = specie
        this.tag_no = tag_no
        this.selected = selected
        this.age = age
        this.blood_pressure = blood_pressure
        this.rabies = rabies
        this.chip_no = chip_no
        this.assigned_doctor = assigned_doctor
    }



}